/**
 * Fingerprint Service router for CRU(!D) operations.
 * @param {string} apiUrl
 * @returns {FingerprintService}
 * @constructor
 */
window.FingerprintService = function FingerprintService(apiUrl) {
  var _this = this;

  /**
   * URL for API calls
   */
  var API_URL = apiUrl;

  /**
   * Possible API_METHODS
   * @type {{GET: string, CREATE: string, UPDATE: string, FIND: string}}
   */
  var API_METHODS = {
    GET: 'get',
    CREATE: 'create',
    UPDATE: 'update',
    FIND: 'find'
  };

  /**
   * Do the Read request for fingerprintId
   * @param {string} id
   * @param {function} onSuccess
   * @param {function} onError
   */
  _this.get = function (id, onSuccess, onError) {
    var requestParams = _getBasicRequestParamsForMethod(API_METHODS.GET, id);
    requestParams.success = onSuccess;
    requestParams.error = onError;

    _sendRequest(requestParams);

    return _this;
  };

  /**
   * Do the Create request with given data.
   *
   * @param {object} data
   * @param {function} onSuccess
   * @param {function} onError
   * @returns {FingerprintService}
   */
  _this.create = function (data, onSuccess, onError) {
    var requestParams = _getBasicRequestParamsForMethod(API_METHODS.CREATE);
    requestParams.data = data;
    requestParams.success = onSuccess;
    requestParams.error = onError;

    _sendRequest(requestParams);

    return _this;
  };

  /**
   * Do the Update request for given fingerprintId
   * @param {string}} id
   * @param {string} fingerprintParts
   * @param {object} data
   * @param {function} onSuccess
   * @param {function} onError
   */
  _this.update = function (id, fingerprintParts, data, onSuccess, onError) {
    var requestParams = _getBasicRequestParamsForMethod(API_METHODS.UPDATE, id);
    requestParams.data = fingerprintParts;
    if (data && typeof data === 'object') {
      requestParams.data.data = data;
    }

    // no need to sanitize/cast here
    requestParams.success = onSuccess;
    requestParams.error = onError;

    _sendRequest(requestParams);

    return _this;
  };

  /**
   * Do the Read request with given fingerprint parts.
   *
   * @param {object} fingerPrintParts
   * @param {function} onSuccess
   * @param {function} onError
   */
  _this.find = function (fingerPrintParts, onSuccess, onError) {

    var requestParams = _getBasicRequestParamsForMethod(API_METHODS.FIND);
    requestParams.data = fingerPrintParts;
    requestParams.success = onSuccess;
    requestParams.error = onError;

    _sendRequest(requestParams);

    return _this;
  };

  /**
   * Sends the request to server.
   * @param {object} params
   * @private
   */
  function _sendRequest(params) {
    params = _sanitizeRequestParams(params);
    _validateRequestParams(params);

    $.ajax(params);

  }

  /**
   * Formats endpoint url with given path
   * @param path
   * @returns {string}
   * @private
   */
  function _getEndpointUrl(path) {
    path = path || '';

    return API_URL + '/' + path;
  }

  /**
   * Sanitizes request params.
   *
   * @param {object} params
   * @private
   * @return {object} params
   */
  function _sanitizeRequestParams(params) {
    var defaults = {
      url: null,
      method: null,
      success: function () {
      },

      error: function () {
      },

      complete: function () {
      }
    };

    var cleanParams = $.extend(true, {}, defaults, params);

    if ('data' in cleanParams && params.method !== 'GET') {
      cleanParams.data = JSON.stringify(cleanParams.data);
    }

    return cleanParams;
  }

  /**
   * Validates request params.
   *
   * @param {object} params
   * @private
   * @throws {Error}
   * @returns {{url: string, method: string, dataType: string, contentType: string, success: string, error: string, complete: string}}
   */
  function _validateRequestParams(params) {
    var requiredParamsConfiguration = {
      url: 'string',
      method: 'string',
      dataType: 'string',
      contentType: 'string',
      success: 'function',
      error: 'function',
      complete: 'function'
    };

    var optionalParams = [
      'contentType',
      'dataType'
    ];

    if (typeof params !== 'object') {
      throw new Error('Params must be an object');
    }

    var key;

    for (key in params) {

      if (
        typeof requiredParamsConfiguration[key] !== 'undefined'
        && typeof params[key] !== requiredParamsConfiguration[key]
      ) {
        if (key in optionalParams && !params.hasOwnProperty(key)) {
          continue;
        }

        throw new Error(
          'Invalid param: ' + key + '. Expected ' +
          requiredParamsConfiguration[key] + ', ' + typeof params[key] + ' given for key: ' + key + '.'
        );
      }
    }

    return requiredParamsConfiguration;
  }

  /**
   * Gets base params for fiven method.
   * (method, contentType, url, dataType)
   *
   * @param {string} methodId - should be one of API_METHODS constant
   * @param {string} fingerprintId
   * @returns {*}
   * @private
   */
  function _getBasicRequestParamsForMethod(methodId, fingerprintId) {
    fingerprintId = fingerprintId || null;
    var params;

    switch (methodId) {
      case API_METHODS.GET:
        params = {
          method: 'GET',
          url: _getEndpointUrl(fingerprintId)
        };
        break;

      case API_METHODS.CREATE:
        params = {
          method: 'POST',
          contentType: 'application/json',
          url: _getEndpointUrl()
        };
        break;

      case API_METHODS.UPDATE:
        params = {
          method: 'POST',
          contentType: 'application/json',
          dataType: 'json',
          url: _getEndpointUrl(fingerprintId)
        };
        break;

      case API_METHODS.FIND:
        params = {
          method: 'GET',
          contentType: 'application/json',
          dataType: 'json',
          url: _getEndpointUrl()
        };

        break;

      default:
        throw new Error('Unsupported method: ' + methodId);
    }

    return params;
  }

  return _this;
};



// WEBPACK FOOTER //
// ./Library/1.0/common/Fingerprint/Models/FingerprintService.js